"use client";

import {Block} from "@/lib/interfaces/blocks";
import Link from "next/link";
import {usePathname} from "next/navigation";
import {useEffect, useState} from "react";
import BulbIcon from "@/components/icons/BulbIcon";
import {removeHtmlTags, slugify} from "@/lib/helpers/string";

interface SideNavItemProps {
    idx: any
    block: Block
    containerRef: any
}

interface SideNavProps {
    blocks: Block[]
    containerRef: any
}

const SideNavItem = ({idx, block, containerRef}: SideNavItemProps) => {
    const pathname = usePathname();

    let title: string|null = null;
    if (block.hasOwnProperty('content') && block.content.hasOwnProperty('sidebar_title') && block.content.sidebar_title) {
        if (block.content.sidebar_title.hasOwnProperty('en')) {
            title = removeHtmlTags(block.content.sidebar_title.en ?? '');
        } else {
            title = removeHtmlTags(block.content.sidebar_title ?? '');
        }
    }

    const handleClick = (e: any) => {
        e.preventDefault();
        const target = containerRef.current.querySelector(`#${slugify(title)}`);
        if (target) {
            const targetPosition = (target.getBoundingClientRect().top + window.scrollY) - 60;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth',
            })
            history.pushState(null, '', `${pathname}#${slugify(title)}`)
        }
    }

    if (title && title.length) {
        return (
            <Link key={idx} href={`${pathname}#${slugify(title)}`} data-scrollto={`${slugify(title)}`} onClick={handleClick} className={`navPage-item`}>
                <span className={`icon`}>
                    <BulbIcon/>
                </span>
                <span className={`label`}>{title}</span>
            </Link>
        )
    }
}

export default function BlockGeneratedSideNav(props: SideNavProps) {
    const items = props.blocks.map((block, key) => {
        return <SideNavItem key={key} idx={key} block={block} containerRef={props.containerRef} />
    });
    return (
        <nav className="eo-navPage">
            {items}
        </nav>
    )
}